import { toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-0b826ff2")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_fa = _resolveComponent("fa")

  return (_openBlock(), _createBlock("button", {
    class: ["flex items-center justify-center w-32 p-2 py-1 text-xs bg-gray-800 border rounded focus:outline-none opacity-30 hover:opacity-100", {
      'opacity-100 border-blue-400': _ctx.complete || _ctx.unlocked,
      'bg-blue-400': _ctx.complete,
      'cursor-default': _ctx.readonly,
      'bg-gray-600': _ctx.isLoading,
      'animate-pulse': _ctx.isLoading
    }],
    disabled: _ctx.readonly || _ctx.isLoading,
    "data-testid": _ctx.event.name
  }, [
    _createTextVNode(_toDisplayString(_ctx.event.name) + " ", 1),
    (_ctx.complete)
      ? (_openBlock(), _createBlock(_component_fa, {
          key: 0,
          icon: "check",
          type: "fas",
          class: "pl-1",
          height: "10"
        }))
      : (!_ctx.unlocked)
        ? (_openBlock(), _createBlock(_component_fa, {
            key: 1,
            icon: "lock",
            type: "fas",
            class: "pl-1",
            height: "10"
          }))
        : _createCommentVNode("", true)
  ], 10, ["disabled", "data-testid"]))
})